import { interviewDataExtractionCustomFieldNamePrefix } from "./customField.js";
const nextInterviewQuestionsDataExtractionFieldKey = "next_interview_questions";
const nextInterviewQuestionsDataExtractionDisplayName = "Next interview questions";
const nextInterviewQuestionsDataExtractionFieldName = `${interviewDataExtractionCustomFieldNamePrefix}:${nextInterviewQuestionsDataExtractionFieldKey}`;
function checkIsNextInterviewQuestionsDataExtractionFieldName(fieldName) {
  return fieldName === nextInterviewQuestionsDataExtractionFieldName;
}
const nextInterviewQuestionsDataExtractionSentinelId = "system:next_interview_questions";
export {
  checkIsNextInterviewQuestionsDataExtractionFieldName,
  nextInterviewQuestionsDataExtractionDisplayName,
  nextInterviewQuestionsDataExtractionFieldKey,
  nextInterviewQuestionsDataExtractionFieldName,
  nextInterviewQuestionsDataExtractionSentinelId
};
//# sourceMappingURL=nextInterviewQuestions.js.map
